import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import roads from "../images/park_map_roads.svg"
import droppin from "../images/map_pin.svg"
import Img from "gatsby-image"

const ParkMap = () => {
  const data = useStaticQuery(graphql`
        query {
            basemap: file(relativePath: {eq: "park_map_base_optimized.png"}) {
                id
                childImageSharp {
                    fluid(maxWidth: 2048) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                }
            }
        }
  `)

  let pins = [
    { x: '16.5%', y: '18.2%', dest: '/porter-ranch-pond-and-playground', name: 'Porter Ranch Pond and Playground' },
    { x: '33.5%', y: '33.5%', dest: '/ventana-lakes-north-park-and-ponds', name: 'Ventana Lakes North Park and Ponds' },
    { x: '49.5%', y: '51.5%', dest: '/east-ventana-parkway-recreation-center', name: 'East Ventana Parkway Rec Center' },
    { x: '68.5%', y: '55.5%', dest: '/castello-lakes-playground-and-recreation-center', name: 'Castello Lakes Playground and Rec Center' },
    { x: '84.0%', y: '39.4%', dest: '/dog-park-at-ventana-lakes', name: 'Dog Park at Ventana Lakes' },
  ]

  return (
    <div className="parks-map">
      <div className="base-map-container">
        <Img fluid={data.basemap.childImageSharp.fluid} />
      </div>
      <img className="roads-map" src={roads} alt="" />
      <div className="drop-pin-wrapper">
        {pins.map(pin => (
          <Link className="drop-pin" style={{ left: pin.x, top: pin.y }} to={`${pin.dest}`}><img className="w-8 drop-shadow-lg" src={droppin} alt={pin.name} />
            <div className="drop-pin-label">{pin.name}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default ParkMap
